import { ApiService } from "src/network/apiService";
import {
  IAddNewBusinessNumberRequest,
  IAddNewBusinessNumberResponse,
  IBusinessNumber,
} from "src/network/models/AddNewBusinessNumberRequest";
import { IApiResponse } from "src/network/models/ApiResponse";
import { IDeleteBusinessNumberRequest, IFileInfo, INewNumberModel, ServiceStatus } from "src/types/models/apiModels";

export class BusinessNumberViewModel {
  private apiService: ApiService;

  constructor(accessToken: string) {
    this.apiService = new ApiService({ accessToken: accessToken });
  }

  private convertNewNumberToBusinessNumber(
    numbers: INewNumberModel[]
  ): IBusinessNumber[] {
    return numbers.map((number) => ({
      businessNumber: number.number,
      ownershipDocuments: number.ownershipDocuments,
    }));
  }


  async deleteBusinessNumberAsync(businessId: string, businessNumbers: string[]): Promise<{ result?: boolean; error?: string }> {

    const URL = `/onboard/business/${businessId}/numbers`

    const body: IDeleteBusinessNumberRequest = { businessNumbers };
    const result = await this.apiService.deleteAsync<IApiResponse<boolean>, IDeleteBusinessNumberRequest>(URL, body);

    if (result.scResponse.code !== 2000) {
      return {
        result: false,
        error: result.scResponse.message,
      };
    }

    return {
      result: true,
    };
  }

  // Main method to submit business numbers
  async submitBusinessNumbers(
    businessId: string,
    numbers: INewNumberModel[]
  ): Promise<{ result?: IAddNewBusinessNumberResponse; error?: string }> {
    const businessNumbers = this.convertNewNumberToBusinessNumber(numbers);

    const request: IAddNewBusinessNumberRequest = {
      businessId: businessId,
      businessNumbers: businessNumbers,
    };

    console.debug(`result = ${JSON.stringify(request)}`);

    const URL = `/onboard/business/${businessId}/numbers`
    const result = await this.apiService.postAsync<IApiResponse<IAddNewBusinessNumberResponse>, IAddNewBusinessNumberRequest>(URL, request);

    // Handle API response(You can uncomment and modify the response check as needed)
    if (result.scResponse.code !== 2000) {
      return {
        result: undefined,
        error: result.scResponse.message,
      };
    }

    return {
      result: result.scResponse.data,
    };
  }

  async getNumbers(businessId: string): Promise<INewNumberModel[]> {
    const url = `/onboard/business/${businessId}/numbers`;

    const result = await this.apiService.getAsync<IApiResponse<any[]>>(url);

    if (result.scResponse.code === 2000) {
      const data = result.scResponse.data;
      const mappedData: INewNumberModel[] = data.map((number) => {
        return {
          number: number.businessNumber.startsWith("+")
            ? number.businessNumber
            : `+${number.businessNumber}`,

          ownershipDocuments: (number.ownershipDocuments || []).map((doc: IFileInfo) => {
            return {
              fileName: doc.fileName || "Unknown file",
              signedUrl: doc.signedUrl || "1.0",
            };
          }),

          status: number.status as ServiceStatus,
        };
      });

      return mappedData;
    }
    return [];
  }
}
